module.exports = __webpack_public_path__ + "img/goods.ab2baa00.png";